import { render } from "./NotificationsItem.vue?vue&type=template&id=76fc97ba&scoped=true"
import script from "./NotificationsItem.vue?vue&type=script&lang=js"
export * from "./NotificationsItem.vue?vue&type=script&lang=js"

import "./NotificationsItem.vue?vue&type=style&index=0&id=76fc97ba&lang=scss"
import "./NotificationsItem.vue?vue&type=style&index=1&id=76fc97ba&scoped=true&lang=scss"
import "./NotificationsItem.vue?vue&type=style&index=2&id=76fc97ba&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fc97ba"]])

export default __exports__